import { categoryDetailLinkListStyles } from "@insite/content-library/Widgets/Category/CategoryDetailLinkList";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import { COLORS, TYPOGRAPHY } from "@tSurya/theme/design";
import { css } from "styled-components";

categoryDetailLinkListStyles.container = {
    gap: 0,
    css: css`
        padding-left: 20px;
        margin-top: 60px;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    margin-top: 30px;
                    padding-left: 0px;
                    display: none;
                `,
                css`
                    margin-top: 30px;
                    padding-left: 0px;
                    display: none;
                `,
                null,
                null,
                null,
            ])};
    `,
};
categoryDetailLinkListStyles.subCategoryNameLinkItem = {
    width: 12,
    css: css`
        padding-bottom: 15px;
        span {
            font-family: ${TYPOGRAPHY.fontFamily.title};
            font-style: normal;
            font-weight: ${TYPOGRAPHY.weight.bold};
            font-size: ${TYPOGRAPHY.size.smaller};
            line-height: ${TYPOGRAPHY.lineHeight.base};
            color: ${getColor("text.main")} !important;
        }
    `,
};
